<coin-v2-card
  padding="none"
  [ngStyle]="{ 'grid-template-columns': $safeNavigationMigration(columnWidths?.join(' ')) }">
  <ng-content></ng-content>
</coin-v2-card>
